// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 14 ? "bh-helper-instance" : chunkId) + "-legacy." + {"14":"f5359476","240":"5ac99962","271":"fc456a33","295":"b3e737a2","299":"7c852176","323":"79d65e19","488":"7d19d940","496":"10f8d13a","543":"9c4062ec","684":"54965e78","710":"f056baed","833":"b02fee74","968":"8f155d42"}[chunkId] + ".js";
};